export default __webpack_public_path__ + "static/media/fayez.7850f530.jpeg";